import React from 'react';
import { Link } from 'react-router-dom';

const AuthorName = ({userName}) => (
	<Link to={`/viewprofile/${userName}`} target="_blank">{userName == 'system' || userName == 'admin' ? 'GrammarError.com' : userName}</Link>
)

export default AuthorName;